import * as React from "react";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Note from "../../model/note/Note";
import {Option} from "ts-option";
import DateTimePicker from "../../hiberUiKit/src/molecules/DateTimePicker/DateTimePicker";
import {IMentionData} from "react-mentions";
import MentionUtils from "../../utils/MentionUtils";
import UserMention from "../mention/UserMention";
import {OnSuccess} from "../../store/action/actionHelpers";
import moment = require("moment");
import {UserRole} from "../../model/user/UserRole";

interface IProps {
	/**
	 * Note to edit.
	 */
	noteToEdit?: Option<Note>;
	/**
	 * Add note action.
	 * @param {string} content note text.
	 * @param {string} extendedContent note extended text.
	 * @param {moment.Moment} reminder reminder date.
	 */
	onSubmit: (content: string,
		extendedContent: string,
		reminder: moment.Moment,
		mentions: IMentionData[],
		onSuccess: OnSuccess,
		onMentionSuccess: OnSuccess) => void
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
}

interface IState {

	/**
	 * Note content.
	 */
	noteContent: string;
	/**
	 * Extended note content.
	 */
	noteExtendedContent: string;
	/**
	 * Note reminder datetime.
	 */
	noteReminderDateTime: moment.Moment | null;
	/**
	 * Mentions in note content
	 */
	mentions: IMentionData[];
}

export default class ReminderTab extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			noteContent: "",
			noteExtendedContent: "",
			noteReminderDateTime: null,
			mentions: []
		};
		this.onDateTimeChange = this.onDateTimeChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.reminderDataInvalid = this.reminderDataInvalid.bind(this);

	}

	componentDidMount() {
		this.props.noteToEdit.map(n => {
			this.setState({
				noteContent: n.content,
				noteExtendedContent: n.extendedContent,
				noteReminderDateTime: n.reminderDate.orNull,
				mentions: MentionUtils.getMentions(n.content)
			});
		});
	}

	componentWillReceiveProps(nextProps: IProps) {
		nextProps.noteToEdit.map(n => {
			this.setState({
				noteContent: n.content,
				noteExtendedContent: n.extendedContent,
				noteReminderDateTime: n.reminderDate.orNull,
				mentions: MentionUtils.getMentions(n.content)
			});
		});
	}

	render() {
		return (
			<div className={"c-reminder-tab"}>
				<UserMention onChange={this.onChange}
							 value={this.state.noteExtendedContent}
							 placeholder={"Create a simple reminder… example: Call customer, Send follow-up email"}
							 onlyAgentsAdminsAndBdps/>
				<div className={"c-reminder-tab_actions"}>
					<DateTimePicker initialDateTime={this.state.noteReminderDateTime} onDateTimeChange={this.onDateTimeChange}/>
					<ButtonPrimary label={this.props.noteToEdit.isDefined ? "Update Reminder" : "Add Reminder"}
								   onClick={this.onSubmit}
								   disabled={this.reminderDataInvalid()}/>
				</div>
			</div>
		);
	}

	private reminderDataInvalid() {
		return this.props.isLoading || !this.state.noteExtendedContent.trim().length ||
			(this.state.noteReminderDateTime ? !this.state.noteReminderDateTime.isValid() : true);
	}

	private onDateTimeChange(dateTime: moment.Moment) {
		this.setState({noteReminderDateTime: dateTime});
	}

	private onChange(evt: React.ChangeEvent<HTMLTextAreaElement>, mentions: IMentionData[], plainText: string) {
		this.setState({noteExtendedContent: evt.target.value, noteContent: plainText, mentions});
	}

	private onSubmit() {
		this.props.onSubmit(this.state.noteContent, this.state.noteExtendedContent, this.state.noteReminderDateTime,
			this.state.mentions,
			() => { this.setState({noteContent: "", noteExtendedContent: "", noteReminderDateTime: null}) },
			() => this.setState({mentions: []}));
	}

}